import { component } from 'picoapp';
import { gsap } from 'gsap';

export default component((node, ctx) => {
  const EXPANDED_CLASS = 'is-expanded';
  let accordions, contents;

  const init = () => {
    getReferenceElements();
    saveExpandedHeights();
    hideAllAccordionContents();
    addEventListeners();
  };

  const getReferenceElements = () => {
    accordions = node.querySelectorAll('.js-accordion-item');
    contents = node.querySelectorAll('.js-accordion-contents');
  };

  const hideAllAccordionContents = () => {
    accordions.forEach(accordion => {
      $(accordion).removeClass(EXPANDED_CLASS);
      gsap.set(accordion, {
        autoAlpha: 1,
        stagger: 0.1,
        overwrite: true,
      });
    });
  };

  const saveExpandedHeights = () => {
    contents.forEach(element => {
      gsap.set(element, { height: 'auto', overwrite: true });
      element.dataset.height = element.clientHeight;
      gsap.set(element, { height: 0, autoAlpha: 0 });
    });
  };

  const addEventListeners = () => {
    accordions.forEach(accordion => {
      accordion.addEventListener('click', (e) => {
        toggleAccordion(e, accordion);
      });
    });

    window.addEventListener('resize', saveExpandedHeights);
    window.addEventListener('resize', hideAllAccordionContents);
  };

  const toggleAccordion = (e, accordion) => {
    const contents = accordion.querySelector('.js-accordion-contents');
    if (e.currentTarget === contents) return;

    const toggleButton = accordion.querySelector('.js-accordion-toggle');

    if ($(accordion).hasClass(EXPANDED_CLASS)) {
      $(accordion).removeClass(EXPANDED_CLASS);

      gsap.to(contents,
        {
          autoAlpha: 0,
          height: 0,
          duration: 0.2,
          overwrite: true,
        });
      gsap.to(toggleButton,
        {
          rotate: 0,
          duration: 0.25,
          overwrite: true,
        });

    } else {
      gsap.to(contents,
        {
          autoAlpha: 1,
          height: contents.dataset.height,
          duration: 0.2,
          overwrite: true,
        });
      gsap.to(toggleButton,
        {
          rotate: 135,
          duration: 0.25,
          overwrite: true,
        });
      $(accordion).addClass(EXPANDED_CLASS);
    }
  };

  init();
  
});